(function () {
  function getProductInfo() {
    return document.querySelector('product-info');
  }

  function getSectionId(productInfo) {
    return productInfo?.dataset?.section;
  }

  function getSelectedColor(productInfo) {
    const fieldset = productInfo.querySelector('.be-product-form__input--color-image');
    if (!fieldset) return null;
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function mediaMatchesColor(colorsStr, color) {
    if (!color || !colorsStr) return false;
    return colorsStr.split(',').map((s) => s.trim()).filter(Boolean).includes(color);
  }

  function filterGalleryByColor(productInfo, color) {
    if (!productInfo || !color) return;

    const sectionId = getSectionId(productInfo);
    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery || !sectionId) return;

    const slides = gallery.querySelectorAll(`#Slider-Gallery-${sectionId} > li[data-media-id]`);
    const hasMatch = Array.from(slides).some(slide => mediaMatchesColor(slide.dataset.beColors || '', color));
    slides.forEach((slide) => {
      const colors = slide.dataset.beColors || '';
      const show = mediaMatchesColor(colors, color) || (!hasMatch && !colors.trim());
      slide.classList.toggle('be-media-hidden', !show);
    });

    const thumbs = gallery.querySelectorAll(`#Slider-Thumbnails-${sectionId} > li[data-target]`);
    thumbs.forEach((thumb) => {
      const targetId = thumb.dataset.target;
      const slide = gallery.querySelector(`li[data-media-id="${targetId}"]`);
      const show = slide && !slide.classList.contains('be-media-hidden');
      thumb.classList.toggle('be-media-hidden', !show);
    });

    const firstVisible = gallery.querySelector(
      `#Slider-Gallery-${sectionId} > li[data-media-id]:not(.be-media-hidden)`
    );
    if (firstVisible && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(firstVisible.dataset.mediaId, true);
    }
  }

  function syncColorSwatchSelectedState(productInfo) {
    const fieldset = productInfo.querySelector('.be-product-form__input--color-image');
    if (!fieldset) return;
    fieldset.querySelectorAll('.be-color-swatch-label').forEach((label) => {
      label.classList.remove('be-color-swatch-label--selected');
    });
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    if (checked) {
      const label = fieldset.querySelector(`label[for="${checked.id}"]`);
      label?.classList.add('be-color-swatch-label--selected');
    }
  }

  function initBeProductPage() {
    const productInfo = getProductInfo();
    if (!productInfo) return;

    const variantSelects = productInfo.querySelector('variant-selects[data-be-color-filter]');
    if (!variantSelects) return;

    const applyFilter = () => {
      const color = getSelectedColor(productInfo);
      if (color) {
        filterGalleryByColor(productInfo, color);
        syncColorSwatchSelectedState(productInfo);
      }
    };

    applyFilter();

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const sectionId = getSectionId(productInfo);
        if (data?.sectionId !== sectionId) return;
        requestAnimationFrame(applyFilter);
      });
    }

    productInfo.addEventListener('change', (event) => {
      if (event.target.closest('.be-product-form__input--color-image')) {
        const color = event.target.value;
        if (color) filterGalleryByColor(productInfo, color);
        syncColorSwatchSelectedState(productInfo);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBeProductPage);
  } else {
    initBeProductPage();
  }

  document.addEventListener('product-info:loaded', initBeProductPage);
})();

/* =====================================================================
   Ürün detay sayfası ana görsel — imleç-takipli büyüteç
   (koleksiyon/anasayfa kartlarıyla AYNI his: tüm görsel değil, yalnızca
   farenin gezdiği bölge büyür). Görsel boyutu/oranı değişmez.
   Sadece masaüstü (hover:hover, pointer:fine); mobilde mevcut
   tıkla-tam-ekran zoom (be-product-zoom.js) korunur.
   ===================================================================== */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var ZOOM = 2; // büyütme oranı (1.8–2.5 arası ayarlanabilir)

  function bindOne(media) {
    if (!media || media.dataset.bePdpZoom === '1') return;
    media.dataset.bePdpZoom = '1';
    media.style.cursor = 'zoom-in';

    media.addEventListener('mousemove', function (e) {
      var img = media.querySelector('img');
      if (!img) return;
      var r = media.getBoundingClientRect();
      var px = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
      var py = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
      img.style.transition = 'transform 0.12s ease-out';
      img.style.transformOrigin = px + '% ' + py + '%';
      img.style.transform = 'scale(' + ZOOM + ')';
    });

    media.addEventListener('mouseleave', function () {
      var img = media.querySelector('img');
      if (!img) return;
      img.style.transform = '';
      img.style.transformOrigin = '';
    });
  }

  function bindAll() {
    document
      .querySelectorAll('.product__media-item .product-media-container .media')
      .forEach(bindOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  document.addEventListener('product-info:loaded', bindAll);

  // Varyant değişimi / slider ile galeri yeniden oluşunca tekrar bağla
  if (window.MutationObserver) {
    new MutationObserver(bindAll).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
